import { memo } from "react";

const TrendUpIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3334 5.83398L11.7762 12.3912C11.4462 12.7212 11.2812 12.8862 11.0909 12.948C10.9236 13.0024 10.7432 13.0024 10.5759 12.948C10.3857 12.8862 10.2206 12.7212 9.89058 12.3912L7.60956 10.1102C7.27954 9.78015 7.11454 9.61507 6.92426 9.55332C6.75689 9.4989 6.57661 9.4989 6.40923 9.55332C6.21896 9.61507 6.05396 9.78015 5.72394 10.1102L1.66675 14.1673M18.3334 5.83398H12.5001M18.3334 5.83398V11.6673"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(TrendUpIcon);
